import { BarChart3Icon } from '@/components/ui/icons'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { PageContainer } from '@/components/layout/page-container'
import { ComingSoonCard } from '@/features/account-hub/components/coming-soon-card'

export const Route = createFileRoute('/_app/declarations/')({
  component: DeclarationsPage,
})

function DeclarationsPage(): JSX.Element {
  return (
    <PageContainer>
      <ComingSoonCard
        icon={<BarChart3Icon />}
        title="Declaraciones"
        description="Aquí podrás dar seguimiento a tus declaraciones fiscales mensuales y anuales."
      />
    </PageContainer>
  )
}
